/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { MenuDaypartResult } from '../../models/menu-daypart-result';

export interface DaypartsDaypartIdMenusMenuIdGet$Params {
  'Active-Tenant-Identifier': string;
  daypartId: string;
  menuId: string;
}

export function daypartsDaypartIdMenusMenuIdGet(http: HttpClient, rootUrl: string, params: DaypartsDaypartIdMenusMenuIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & MenuDaypartResult>> {
  const rb = new RequestBuilder(rootUrl, daypartsDaypartIdMenusMenuIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('daypartId', params.daypartId, {});
    rb.path('menuId', params.menuId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & MenuDaypartResult>;
    })
  );
}

daypartsDaypartIdMenusMenuIdGet.PATH = '/dayparts/{daypartId}/menus/{menuId}';
